exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-label {\n  font-size: 85%;\n  color: #606060; }\n\n.edit-button {\n  color: blue;\n  cursor: pointer; }\n\n.mat-option {\n  line-height: 16px !important;\n  height: 56px !important;\n  padding: 12px 16px !important; }\n\n.mat-option + .mat-option {\n  border-top: 1px solid #a0a0a0 !important; }\n\n.mat-autocomplete-panel {\n  max-height: 300px !important; }\n\n.qo-box {\n  background-color: #ffffff;\n  padding: 15px;\n  margin: 0 0 10px 0; }\n\n.qo-panel-label {\n  width: 100%;\n  color: #a0a0a0;\n  padding-bottom: 5px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.div-rt-divider {\n  border-right: 1px solid #a0a0a0; }\n\n.text-color-grey {\n  color: #a0a0a0; }\n\n.no-wrap {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.quote-section {\n  margin-left: 1em; }\n\n.quote-section label {\n  color: black;\n  font-weight: 500; }\n\n.quote-section input[type=\"checkbox\"] {\n  position: absolute;\n  top: 5px;\n  margin-left: 0.4em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/oes/quick-order/quick-order.component.scss
// module id = ../../../../../angular/app/views/oes/quick-order/quick-order.component.scss
// module chunks = main